import { render, staticRenderFns } from "./FeatureTypeEdit.vue?vue&type=template&id=39f492fc"
import script from "./FeatureTypeEdit.vue?vue&type=script&lang=js"
export * from "./FeatureTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./FeatureTypeEdit.vue?vue&type=style&index=0&id=39f492fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports